const boneAndJointDisorders = [
    "Osteoarthritis",
    "Rheumatoid Arthritis",
    "Osteoporosis",
    "Gout",
    "Fibromyalgia",
    "Ankylosing Spondylitis",
];

const msk = boneAndJointDisorders.reduce((accumulator, disease) => {
    accumulator.push({category: 'Musculoskeletal', disease})
    return accumulator
}, [])

export default msk